import Vue from 'vue'
import Cookies from 'js-cookie'
import store from '~/store'
import Meta from 'vue-meta'
import routes from './routes'
import Router from 'vue-router'
import { sync } from 'vuex-router-sync'
import axios from 'axios'

Vue.use(Meta)
Vue.use(Router)

const router = make(
  routes({ authGuard, guestGuard })
)

sync(store, router)

export default router

/**
 * Create a new router instance.
 *
 * @param  {Array} routes
 * @return {Router}
 */
function make (routes) {
  const router = new Router({
    routes,
    scrollBehavior,
    mode: 'history'
  })

  // Register before guard.
  router.beforeEach(async (to, from, next) => {
    insertErrorLog('to_from',to.name)
    insertErrorLog('from',from.name)
    // Close dialog
    store.dispatch('changePage')

    if ((!store.getters['auth/authenticated'] || !store.getters['member/isMember']) && store.getters['auth/token']) {
      try {
        await store.dispatch('auth/fetchUser')
        if (store.getters['member/isMember']) {
          store.dispatch('cart/resetGuestDetails')
          await store.dispatch('fetchMemberAll')
          await this.$store.dispatch('fetchMembershipInfo')
        }
      } catch (e) { }
    }

    if (store.getters['member/profile'] || store.getters['auth/user']) {
      // For the restaurants that has logged in state.user, but halfway they remove loyalty
      if (!store.getters['config/allowLogin'] || (store.getters['member/profile'] && parseInt(store.getters['member/profile'].loyalty_group_id) !== parseInt(store.getters['config/loyaltyGroupId']))) {
        await store.dispatch('auth/logout')
        await store.dispatch('resetAllData')
      }
    }

    const authPages = [
      'login', 'register', 'register2', 'password.request', 'password.reset', 'password.reset2', 'password.reset3',
      'facebook'
    ]
    if (authPages.includes(to.name) && !store.getters['config/allowLogin']) {
      next({ name: 'welcome' })
    }

    const specialPages = [
      'outlets', 'welcome', 'login', 'register', 'register2', 'cbs', 'payment', 'submit',
      'password.request', 'password.reset', 'password.reset2', 'password.reset3', 'browser', 'advertised_outlets'
    ]
    const outletIndependentPages = [
      'password.request', 'password.reset', 'password.reset2', 'password.reset3', 'orders', 'order', 'order2',
      'bills', 'bill', 'submit', 'payment', 'payment2', 'inbox', 'mail', 'receipt',
      'receipts', 'cbs', 'advertised_outlets'
    ]

    // To fix the blank issue of opening outlets page directly
    if (to.name === 'outlets') {
      await store.dispatch('fetchOutlets')
    }

    if (to.name === 'login') {
      await store.dispatch('fetchOutlets')
      await store.dispatch('fetchConfig')
    }

    if (to.name === 'welcome') {
      const prefix = window.config.prefix

      const gid = to.query.gid || Cookies.get(`${prefix}gid`) ? to.query.gid || Cookies.get(`${prefix}gid`) : store.getters['config/gid']

      if (gid && parseInt(gid) !== parseInt(store.getters['config/gid'])) {
        store.dispatch('changeGroup', gid)
      }
      await store.dispatch('fetchOutlets')
      if (to.query.rid) {
        if (parseInt(to.query.rid) === 0) {
          store.dispatch('changeOutlet', 0)
          next({ name: 'outlets' })
        } else if (parseInt(to.query.rid) !== parseInt(store.getters['config/rid'])) {
          store.dispatch('changeOutlet', to.query.rid)
        } else {
          // Refresh cookies expiry time
          store.dispatch('config/changeRid', to.query.rid)
        }
      }

      var type = Cookies.get(`${prefix}type`)
    // || (typeof(type) != "undefined" && type == 'list')
      if (!store.getters['config/rid']) {
        store.dispatch('changeOutlet', 0)
        if (Cookies.get(`${prefix}m_token`)) {
          // for timbre expo, hard code gems.iorder_group.id
          insertErrorLog('beforeEach','for timbre expo')
          next({name: 'area1', params: { id: 14, is_expo: true }})
        } else {
          insertErrorLog('beforeEach','next({ name: outlets })')
          next({ name: 'outlets' })
        }
      } else {
        // Fetch here, before changeTable
        await store.dispatch('fetchOutletConfig')
        if (to.query.tb && store.getters['config/withTableNo']) {
          store.dispatch('changeTable', to.query.tb)
        }

        await store.dispatch('fetchOutletCats')
        await store.dispatch('fetchMode')

        if (to.query.mode && ['dine_in', 'takeaway', 'delivery'].includes(to.query.mode)) {
          store.dispatch('setModeByString', to.query.mode)
        }

        await store.dispatch('fetchMenuCats')

        if (Cookies.get(`${prefix}m_token`)) {
          insertErrorLog('beforeEach','Cookies.get(`${prefix}m_token`)')
          await store.dispatch('config/setMemberToken', {
            m_token: Cookies.get(`${prefix}m_token`),
            m_id: Cookies.get(`${prefix}mid`)
          })
          await store.dispatch('memberTokenLogin')
          if (!store.getters['auth/loginByMemberToken']) {
            insertErrorLog('beforeEach','auth/loginByMemberToken')
            next({ name: 'welcome' })
          }
        } else {
          insertErrorLog('beforeEach','config/resetMemberToken')
          await store.dispatch('config/resetMemberToken')
        }
        if (to.query.register) {
          next({ name: 'register', params: { referral_id: to.query.referral_id,referral_name:to.query.referral_name}})
        } else {
          if (from.name !== 'menu') {
            const iorderMToken = document.cookie.indexOf('iorder_m_token')
            if (from.name !== 'area1' && (Cookies.get(`iorder_m_token`) || iorderMToken !== -1)) {
              insertErrorLog('beforeEach' ,'iorder_m_token')
              next({ name: 'area1', params: { id: 14, is_expo: false }})
            } else {
              insertErrorLog('beforeEach','menu')
              next({ name: 'menu', params: { gid: gid, rid: parseInt(store.getters['config/rid']) }})
            }
          }
        }
      }
      // ---- If going to any page from non Chrome / non Safari browser
    } else if (to.name !== 'info' && !specialPages.includes(to.name) && (store.getters['config/isInApp'] || store.getters['config/onMaintenance'] || !store.getters['config/isPublishable'])) {
      next({ name: 'info' })
      // -----------------------
    } else if (to.name === 'info' && (!store.getters['config/isInApp'] && !store.getters['config/onMaintenance'] && store.getters['config/isPublishable'])) {
      insertErrorLog('beforeEach','isInApp')
      next({ name: 'welcome' })
      // -----------------------
    } else if ((to.name !== 'outlets' && !outletIndependentPages.includes(to.name)) && !store.getters['config/rid']) {
      if (to.name === 'areas' || to.name === 'area1') await store.dispatch('fetchAreas')
      if (to.name === 'areas') {
        insertErrorLog('beforeEach','areas')
        setLayout(router, to)
        next()
        // -----------------------
      } else if (to.name === 'area1' && !isNaN(to.params.id)) {
        insertErrorLog('beforeEach','area1')
        store.dispatch('resetSelectedArea')
        await store.dispatch('area/setSelectedArea', parseInt(to.params.id))
        setLayout(router, to)
        next()
        // -----------------------
      } else {
        insertErrorLog('beforeEach','outlets')
        next({ name: 'outlets' })
        // -----------------------
      }
    } else if (!specialPages.includes(to.name) && (!store.getters['config/cats'] || !store.getters['config/cats'].length)) {
      next({ name: 'welcome' })
      // -----------------------
    } else if (to.name === 'menu') {
      insertErrorLog('beforeEach','menu1')
      await store.dispatch('fetchMenuCats')
      if (store.getters['area/postalCode']) {
        await store.dispatch('delivery/fetchDeliveryInfo', store.getters['area/postalCode'])
        await store.dispatch('delivery/setAddress')
      }
      setLayout(router, to)
      next()
      // -----------------------
    } else if (to.name === 'addresses' && !store.getters['config/hasDeliveryMode']) {
      next({ name: 'welcome' })
      // -----------------------
    } else if ((to.name === 'bills' || to.name === 'bill') && (!store.getters['member/isMember'] || store.getters['config/mode'].paymentMode !== 1)) {
      insertErrorLog('beforeEach','bills')
      next({ name: 'welcome' })
      // -----------------------
    } else if (to.name === 'guest_details' && (store.getters['member/isMember'] || store.getters['config/mode'].isDinein || !store.getters['cart/guestDetailsStatus'].isEmpty || store.getters['cart/guestDetailsStatus'].isFilled || !store.getters['order/paymentMode'] || store.getters['order/paymentMode'].payType !== 'payment')) {
      insertErrorLog('beforeEach','guest_details')
      next({ name: 'welcome' })
      // -----------------------
    } else if ((to.name === 'reservation_tnc' || to.name === 'reservations') && !store.getters['config/enableReservation']) {
      next({ name: 'welcome' })
      // -----------------------
    } else {
      insertErrorLog('beforeEach','setLayout')
      setLayout(router, to)
      next()
    }
  })

  // Register after hook.
  router.afterEach((to, from) => {
    router.app.$nextTick(() => {
      router.app.$loading.finish()
    })
  })

  return router
}

function insertErrorLog (action,content) {
  axios.post('/api/error_log',{
    action: action,
    content: content,
  }).then(response =>{
  })
}

/**
 * Set the application layout from the matched page component.
 *
 * @param {Router} router
 * @param {Route} to
 */
function setLayout (router, to) {
  // Get the first matched component.
  const [component] = router.getMatchedComponents({ ...to })

  if (component) {
    router.app.$nextTick(() => {
      // Start the page loading bar.
      if (component.loading !== false) {
        router.app.$loading.start()
      }

      // Set application layout.
      router.app.setLayout(component.layout || '')
    })
  }
}

/**
 * Redirect to login if guest.
 *
 * @param  {Array} routes
 * @return {Array}
 */
function authGuard (routes) {
  return beforeEnter(routes, (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      next({
        name: 'login',
        query: { redirect: to.fullPath }
      })
    } else if (!store.getters['member/isMember'] && to.name === 'home') {
      next({
        name: 'register2'
      })
    } else if (!store.getters['member/isMember'] && to.name !== 'register2' && !store.getters['config/allowCheckout'].guest) {
      next({
        name: 'register2'
      })
    } else {
      next()
    }
  })
}

/**
 * Redirect home if authenticated.
 *
 * @param  {Array} routes
 * @return {Array}
 */
function guestGuard (routes) {
  return beforeEnter(routes, (to, from, next) => {
    if (store.getters['auth/authenticated']) {
      next({ name: 'home' })
    } else {
      next()
    }
  })
}

/**
 * Apply beforeEnter guard to the routes.
 *
 * @param  {Array} routes
 * @param  {Function} beforeEnter
 * @return {Array}
 */
function beforeEnter (routes, beforeEnter) {
  return routes.map(route => {
    return { ...route, beforeEnter }
  })
}

/**
 * @param  {Route} to
 * @param  {Route} from
 * @param  {Object|undefined} savedPosition
 * @return {Object}
 */
function scrollBehavior (to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition
  }

  const position = {}

  if (to.hash) {
    position.selector = to.hash
  }

  if (to.matched.some(m => m.meta.scrollToTop)) {
    position.x = 0
    position.y = 0
  }

  return position
}



// WEBPACK FOOTER //
// ./src/router/index.js